import React from 'react'
import './footer.css'


import { FaFacebookSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";


const  Footer = () => {
  return (
    
    <footer className="footer section">
    <div className="footer__container container grid">
      <div className="footer__content grid">
        <div className="footer__data">
          <h3 className="footer__title">Travel</h3>
          <p className="footer__description">
            Travel you choose the <br />
            destination, we offer you the <br />
            experience.
          </p>
          <div>
              <a href="https://www.facebook.com/"  class="footer__social">
                <FaFacebookSquare />
              </a>
          
              <a href="https://twitter.com/" class="footer__social">
                <FaSquareXTwitter />
              </a>

              <a href="https://www.instagram.com/" class="footer__social">
                <FaSquareInstagram />
              </a>

              <a href="https://youtube.com/" class="footer__social">
                <FaYoutube />
              </a>
          </div>
        </div>
        <div className="footer__data">
          <h3 className="footer__subtitle">About</h3>
          <ul>
            <li className="footer__item">
              <a href="#about" className="footer__link">
                About Us
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Features
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                New &amp; Blog
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__data">
          <h3 className="footer__subtitle">Company</h3>
          <ul>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Team
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Plan y Pricing
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Become a member
              </a>
            </li>
          </ul>
        </div>
        <div className="footer__data">
          <h3 className="footer__subtitle">Support</h3>
          <ul>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                FAQs
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Support Center
              </a>
            </li>
            <li className="footer__item">
              <a href="#nothing" className="footer__link">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer__rights">
        <p className="footer__copy">© 2023 Romi RA. All rigths reserved.</p>
        <div className="footer__terms">
          <a href="#nothing" className="footer__terms-link">
            Terms &amp; Agreements
          </a>
          <a href="#nothing" className="footer__terms-link">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  </footer>
  )
}

export default Footer 